import { IDropdownOption } from '@fluentui/react';
import { formatDropdownOptions } from 'common/utils';
import { ApprovalSetupFlowCommonData } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/ApprovalSetupFlowCommonData';

export const useDropdownOptions = (
  approvalTypes: ApprovalSetupFlowCommonData | undefined
) => {
  const delayTypesOptions =
    formatDropdownOptions(approvalTypes?.approverDelayTypes?.nodes, {
      getKey: (item) => item.id ?? '',
      getText: (item) => item.delayType || '',
      includeAll: false,
    }) || [];

  const userDistributionOptions =
    formatDropdownOptions(approvalTypes?.userDistributionLists?.nodes, {
      getKey: (item) => item.userId ?? '',
      getText: (item) => item.userName!,
    }) || [];

  const transactionTypesOptions =
    formatDropdownOptions(approvalTypes?.approverTransactionTypes?.nodes, {
      getKey: (item) => item.id || '',
      getText: (item) => item.approvalTransactionType!,
      includeAll: false,
    }) || [];

  const currencies =
    formatDropdownOptions(approvalTypes?.companyCurrencies?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.name!,
      includeAll: false,
    }) || [];

  const additionalBusUnit =
    formatDropdownOptions(approvalTypes?.businessUnits?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.name || '',
      includeAll: false,
    }) || [];

  const conversionOptions =
    formatDropdownOptions(approvalTypes?.exchangeRateTypes?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.phaseName || '',
      includeAll: false,
    }) || [];

  const occupations =
    formatDropdownOptions(approvalTypes?.userOccupationTitles?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.userOccupationTitle!,
      includeAll: false,
    }) || [];

  const ranks: IDropdownOption[] =
    approvalTypes?.userRankTypes?.nodes.map((item) => ({
      key: item.id,
      text: item?.userRank,
      rowTimestamp: item?._rowTimestamp,
      isUpdatable: item?._isUpdatable,
      isDeletable: item?._isDeletable,
    })) || [];

  const companies =
    formatDropdownOptions(approvalTypes?.companies?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.name!,
      includeAll: false,
    }) || [];

  const users =
    formatDropdownOptions(approvalTypes?.users?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.name!,
      includeAll: false,
    }) || [];

  const purchaseOrder =
    formatDropdownOptions(approvalTypes?.companyPurchaseOrderTypes?.nodes, {
      getKey: (item) => item.purchaseOrderTypeId!,
      getText: (item) => item.purchaseOrderType!,
      includeAll: false,
    }) || [];

  const departments =
    formatDropdownOptions(approvalTypes?.departments?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.name!,
      includeAll: false,
    }) || [];

  const departmentTypes =
    formatDropdownOptions(approvalTypes?.departmentTypes?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.departmentType,
      includeAll: false,
    }) || [];

  const departmentGroups =
    formatDropdownOptions(approvalTypes?.departmentGroups?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.name,
      includeAll: false,
    }) || [];

  const tags =
    formatDropdownOptions(approvalTypes?.tags?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.badgeName,
      includeAll: false,
    }) || [];

  const rowSecurity =
    formatDropdownOptions(approvalTypes?.secureRowLevels?.nodes, {
      getKey: (item) => item.id,
      getText: (item) => item.name!,
      includeAll: false,
    }) || [];

  return {
    currencies,
    additionalBusUnit,
    conversionOptions,
    occupations,
    ranks,
    companies,
    users,
    purchaseOrder,
    departments,
    departmentTypes,
    departmentGroups,
    tags,
    rowSecurity,
    transactionTypesOptions,
    userDistributionOptions,
    delayTypesOptions,
  };
};
